// The app itself (sign-in/sign-up, tracker) lives on a separate domain.
// REACT_APP_APP_URL lets preview deploys point at an app preview URL
// instead of production app.vesna.health.
export const APP_URL = process.env.REACT_APP_APP_URL || 'https://app.vesna.health';
